import { useState } from "react";
import { api, toast } from "../../App";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const UnapproveLeadDialog = ({ approval, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);
  const submit = async () => {
    if (!reason.trim()) return toast.error("Please enter a reason");
    setSaving(true);
    try {
      await api.patch(`/lead-approvals/${approval.id}/unapprove`, { reason });
      toast.success(`${approval.lead_name || "Lead"} unapproved — it can be edited again`);
      onDone();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to unapprove lead");
    } finally {
      setSaving(false);
    }
  };
  return (
    <Dialog open={!!approval} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-white" data-testid="lead-unapprove-dialog">
        <DialogHeader>
          <DialogTitle>Unapprove {approval?.lead_number} {approval?.lead_name}</DialogTitle>
          <DialogDescription>The approval is closed and the lead becomes editable again. It can be sent for approval again later.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="lead-unapprove-reason">Reason <span className="text-red-500">*</span></Label>
          <Textarea id="lead-unapprove-reason" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Why is this approval being withdrawn?" data-testid="lead-unapprove-reason-input" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="lead-unapprove-cancel-btn">Cancel</Button>
          <Button onClick={submit} disabled={saving} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="lead-unapprove-confirm-btn">Unapprove</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
